import '../../../App_mobile.css';
import { RouteObject, useNavigate } from 'react-router';
import { CssBaseline, Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom'; // Import Routes and Route
import { CustomRouteObject, mobileRoutes } from '../../../routes';
import AuthService from '../../../services/auth.service';
import Authenticate from '../../pages/authenticate/login';
import { ReactNode, useEffect, useState } from 'react';

export const withRouter = (Component: any) => {
  const Wrapper = (props: any) => {
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};

export default function MobileLayout(): JSX.Element {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(true);

  function renderRoute(value: RouteObject, index: number, element?: ReactNode) {
    return (
      <Route key={index} path={value.path} element={element || value.element}>
        {value.children?.map((route, i) => renderRoute(route, i))}
      </Route>
    );
  }

  function renderCustomRoute(value: CustomRouteObject, index: number, _) {
    const element = !value.isAuthGuarded || isAuthenticated ? value.element : <Authenticate />;

    return renderRoute(value, index, element);
  }

  useEffect(() => {
    AuthService.isAuthenticated().then(setIsAuthenticated);
  }, []);

  return (
    <>
      <CssBaseline />
      <div className='app'>
        <main className='content'>
          <div className='content_body'>
            <Box>
              <Routes>{mobileRoutes.map(renderCustomRoute)}</Routes>
            </Box>
          </div>
        </main>
      </div>
    </>
  );
}
